import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useInterval } from './use-interval';

dayjs.extend(utc);

/**
 * Wrapper around useInterval that return the current time (as a dayjs
 * instance) every given milliseconds.
 */
export function useNow({ offset = 0, delay = 60000 } = {}) {
  return useInterval(() => dayjs.utc().add(offset, 'ms'), delay);
}
